import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from 'classnames';
import { useDispatch} from "react-redux";
import { FormattedMessage } from "react-intl";
import Button from "react-bootstrap/Button";
import { closeHeaderModal, openHeaderModal } from "../../actions/siteadmin/modalActions";
import messages from "../../locale/messages";
import bookingIcon from '/public/dashboard/bookingIcon.svg';
import scheduleIcon from '/public/dashboard/scheduleIcon.svg';
import promoArrowIcon from '/public/dashboard/promoArrowIcon.svg';
import bt from '../../components/commonStyle.css'
import s from './BookingForm.css'

const BookingForm = ({ shouldOpenSafetyMeasure }) => {

    const dispatch = useDispatch()

    const handleChange = async () => {
        dispatch(closeHeaderModal('bookingForm'))
        dispatch(openHeaderModal('providerSelectionForm'))
    }

    const handleClick = () => {
        dispatch(closeHeaderModal('bookingForm'))
        shouldOpenSafetyMeasure && dispatch(openHeaderModal('safetyMeasureForm'))
    }
    const handleScheduleBooking = () => {
        dispatch(closeHeaderModal('bookingForm'))
        dispatch(openHeaderModal('scheduleBookingForm'))
    }
    return (
        <>
            <div className={s.needFormCardContainer}>
                <div onClick={() => handleChange()} className={cx(s.needFormCardFlex, 'svgImg', bt.cursorPointer)}>
                    <div className={s.needFormCardImgContainer}>
                        <img src={bookingIcon} alt="Booking now" />
                        <span className={cx(bt.commonSize16, bt.fontWeight600, bt.primaryColor)}><FormattedMessage {...messages.bookNow} /></span>
                    </div>
                    <img src={promoArrowIcon} alt="promoArrowIcon" className={'iconRotate'} />
                </div>
                <div onClick={handleScheduleBooking} className={cx(s.needFormCardFlex, 'svgImg', bt.cursorPointer)}>
                    <div className={s.needFormCardImgContainer}>
                        <img src={scheduleIcon} alt="Schedule later" />
                        <span className={cx(bt.commonSize16, bt.fontWeight600, bt.primaryColor)}><FormattedMessage {...messages.scheduleLater} /></span>
                    </div>
                    <img src={promoArrowIcon} alt="promoArrowIcon" className={'iconRotate'} />
                </div>
            </div>
            <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                <Button onClick={() => handleClick()} className={bt.btnSecondary}><FormattedMessage {...messages.goBackText} /> </Button>
            </div>
        </>
    )
}

export default withStyles(bt, s)(BookingForm);
